export default __webpack_public_path__ + "img/innovation.0.asset.1f0d5807.png";